import Button from '@atoms/Button/Button';
import RadioInput from '@atoms/Inputs/RadioInput';
import { INTERN_APPLICATION_ID } from '@constants';
import { vacancyFiltersType } from '@lib/proptypes';
import MatchMakerQuestion from '@molecules/MatchMaker/MatchMakerQuestion';
import Modal from '@molecules/Modal/Modal';
import InfoCircleIcon from '@svg/info-circle.svg';
import { useMatchmakerQuestion } from '@utils';
import PropTypes from 'prop-types';
import { useState } from 'react';

import styles from './Matchmaker.module.scss';

const MODAL_ID = 'q2-info-modal';

const filterKey = 'applicationForms';

export default function Question2({ filters, handleNavigation }) {
  const [showHelp, setShowHelp] = useState(false);

  const { inputs, handleChange, handleNextUrl } = useMatchmakerQuestion({
    key: filterKey,
    callback: handleNavigation,
    initialState: state => state.applicationForms,
  });

  return (
    <MatchMakerQuestion
      number={2}
      total={7}
      question="Hoe wil jij bij ons werken?"
      extraClasses={styles.matchMakerQuestion}
    >
      <div className={styles.inputsContainer}>
        {filters[filterKey].map(({ id, title }) => (
          <RadioInput
            key={`application-form-${id}`}
            id={id}
            name={filterKey}
            onChange={handleChange}
            label={title}
            checked={inputs[filterKey] === id.toString()}
            value={id.toString()}
          />
        ))}
      </div>

      <Button
        label="Wat betekent dit?"
        onClick={() => setShowHelp(true)}
        variant="text"
        iconLeft
        Icon={InfoCircleIcon}
        noAnimation
        modifierClass="largeIcon"
        aria-expanded={showHelp}
        aria-controls={MODAL_ID}
      />

      <Modal
        id={MODAL_ID}
        show={showHelp}
        title="Wat betekent dit?"
        onClose={() => setShowHelp(false)}
      >
        <h3 className="u-typography-heading-4 u-mb-1">Medewerker</h3>
        <p>
          Verantwoordelijk voor continue zorg en ondersteuning op een vaste
          locatie of in de flexpool werkzaam op meerdere locaties door in te
          schrijven op openstaande diensten.
        </p>
        <br />

        <h3 className="u-typography-heading-4 u-mb-1">Leerling</h3>
        <p>
          Met een leer-werkovereenkomst via Vitalis in opleiding tot
          professional in de ouderzorg.
        </p>
        <br />

        <h3 className="u-typography-heading-4 u-mb-1">Vrijwilliger</h3>
        <p>
          Bijdragen aan het welzijn van ouderen tegen een
          vrijwilligersvergoeding
        </p>
        <br />

        <h3 className="u-typography-heading-4 u-mb-1">Stagiair</h3>
        <p>Werkervaring opdoen in de praktijk tijdens opleiding</p>
        <br />

        <h3 className="u-typography-heading-4 u-mb-1">Vakantiekracht</h3>
        <p>Tijdelijke ondersteuning in de zomervakantie.</p>
        <br />

        <h3 className="u-typography-heading-4 u-mb-1">ZZP&rsquo;er</h3>
        <p>
          Zelfstandige professional die diensten verleent volgens eigen
          overeenkomst.
        </p>
      </Modal>

      <div className={styles.ctaContainer}>
        <Button
          key="matchmaker-back-button"
          label="Terug"
          href="/matchmaker/1"
          size="smallMobile"
          onClick={handleNavigation}
          color="secondary"
        />

        {inputs.applicationForms === INTERN_APPLICATION_ID ? (
          <Button
            label="Lees meer"
            href="/leren/stagiaires"
            size="smallMobile"
          />
        ) : (
          <Button
            key="matchmaker-next-button"
            label="Volgende"
            href="/matchmaker/3"
            size="smallMobile"
            onClick={handleNextUrl}
            disabled={!inputs.applicationForms}
          />
        )}
      </div>
    </MatchMakerQuestion>
  );
}

Question2.propTypes = {
  filters: vacancyFiltersType,
  handleNavigation: PropTypes.func,
};
